import UXEvents from '@enums/ux-events';

export default [
    {
        key: UXEvents.scenarioDeleted,
    },
];
